import React, { useEffect, useState } from "react";
import styles from "./Styles.module.css";
import { useDispatch, useSelector } from "react-redux";
import {
  checkPrincipalDiagnosisAction,
  setCurrentStageFactorsAction,
  setIsFinalStatePrincipalDiagnosisAction,
  setNumberOfAttemptsPrincipalDiagnosisAction,
} from "../Redux/Case-reducer";
import { useNavigate } from "react-router-dom";
import AlertModal from "./Modals/AlertModal";
import Commentary from "./Modals/Commentary";
import { sendIntermediateResult } from "../Utils/utils";
import Hint from "./Modals/Hint";

const PrincipalDiagnosis = ({ sessionId, devMode }) => {
  const { principalDiagnosis } = useSelector((state) => state.currentCase);
  const [isCurrentStep, setIsCurrentStep] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [alertDescription, setAlertDescription] = useState("");
  const [hint, setHint] = useState(null);
  const [buttonsIsDisabled, setButtonsIsDisabled] = useState(false); // во время всплывания окон кнопки должны блокмроваться
  const [commentary, setCommentary] = useState(false);

  useEffect(() => {
    if (!principalDiagnosis.isCurrentStage) navigate("/");
  }, []);

  // useEffect(() => {
  //   if (principalDiagnosis.isFinalState) setHint(principalDiagnosis.hint);
  // }, []);

  const validatorFunction = () => {
    // функция проверяет корректность ответов и диспатчит попытки
    if (!principalDiagnosis.isFinalState) {
      if (principalDiagnosis.variants.find((variant) => variant.isChecked)) {
        setButtonsIsDisabled(true);
        let correct = false;
        const arrayCorrect = [];
        const arrayRight = [];
        for (let i = 0; i < principalDiagnosis.variants.length; i++) {
          if (principalDiagnosis.variants[i].isCorrectVariant)
            arrayCorrect.push("/");
          if (
            principalDiagnosis.variants[i].isChecked &&
            principalDiagnosis.variants[i].isCorrectVariant
          )
            arrayRight.push("/");
        }
        if (
          arrayCorrect.length == arrayRight.length &&
          !principalDiagnosis.variants.find(
            (variant) => variant.isChecked && !variant.isCorrectVariant
          ) // для диагноза не свойственно выбирать несколько вариантов ответа, поэтому это вынужденная мера
        ) {
          // for (let i = 0; i < principalDiagnosis.variants.length; i++) {
          //   if (
          //     principalDiagnosis.variants[i].isChecked &&
          //     principalDiagnosis.variants[i].isCorrectVariant
          //   )
          setAlertDescription("Диагноз верный!");
          setIsCurrentStep(true);
          dispatch(setCurrentStageFactorsAction());
          correct = true;
          setTimeout(() => {
            setAlertDescription("");
            setButtonsIsDisabled(false);
            setHint(principalDiagnosis.hint);
            // setCommentary(true);
            dispatch(setIsFinalStatePrincipalDiagnosisAction());
          }, 1500);
        }

        if (!correct) {
          setAlertDescription("Скорректируйте диагноз!");
          setTimeout(() => {
            setAlertDescription("");
            setButtonsIsDisabled(false);
          }, 1500);
        }
        if (principalDiagnosis.numberOfAttempts >= 2 && !correct) {
          setTimeout(() => {
            setButtonsIsDisabled(true);
          }, 1600);
          setTimeout(() => {
            setAlertDescription("Даем подсказку!");
          }, 2000);
          setTimeout(() => {
            setAlertDescription("");
          }, 3500);
          setTimeout(() => {
            // setHint(principalDiagnosis.hint); // момент когда выводим окно с подсказкой
            // dispatch(setIsFinalStatePrincipalDiagnosisAction());
            setButtonsIsDisabled(false);
            dispatch(setIsFinalStatePrincipalDiagnosisAction());
            setIsCurrentStep(true);
            dispatch(setCurrentStageFactorsAction());
          }, 4000);
        }
      }
    } else {
      if (isCurrentStep) {
        setHint(principalDiagnosis.hint);
       
      } else navigate("/progression-factors");
    }
  };

  useEffect(() => {
    if (principalDiagnosis.isFinalState) {
      // setCommentary(true); // После закрытия подсказки выводим окно с комментарием
      for (let i = 0; i < principalDiagnosis.variants.length; i++) {
        // далее через цикл выводим правильные ответы
        if (principalDiagnosis.variants[i].isChecked)
          dispatch(checkPrincipalDiagnosisAction(i));
        if (principalDiagnosis.variants[i].isCorrectVariant)
          dispatch(checkPrincipalDiagnosisAction(i));
      }
    }
  }, [principalDiagnosis.isFinalState]);

  const navigateNextOrPrev = (e) => {
    e.target.innerText == "Назад" ? navigate(-1) : validatorFunction();
    if (principalDiagnosis.variants.find((variant) => variant.isChecked))
      dispatch(setNumberOfAttemptsPrincipalDiagnosisAction());
    if (
      e.target.innerText == "Далее" &&
      !principalDiagnosis.isFinalState &&
      !devMode
    )
      sendIntermediateResult(
        principalDiagnosis.variants,
        sessionId,
        "diagnosis"
      );
  };

  return (
    <section className={styles.containerHeadInf}>
      {hint ? (
        <Hint
          hint={hint}
          clouse={setHint}
          current={principalDiagnosis.variants}
          route={"/progression-factors"}
          isCurrentStep={isCurrentStep}
          setIsCurrentStep={setIsCurrentStep}
        />
      ) : commentary ? (
        <Commentary
          id={sessionId}
          devMode={devMode}
          clouse={setCommentary}
          type="diagnosis"
          header="Опишите коротко почему Вы поставили этот диагноз"
        />
      ) : (
        <>
          <span
            onClick={() => setHint(principalDiagnosis.hint)}
            style={{
              display:
                !isCurrentStep && principalDiagnosis.isFinalState
                  ? "block"
                  : "none",
              fontSize: "12px",
              cursor: "pointer",
              right: "10%",
              margin: "0 0 0 auto",
            }}
          >
            см. подсказку
          </span>
          <h2>
            {!principalDiagnosis.isFinalState
              ? principalDiagnosis.headName
              : "Верный диагноз"}
          </h2>
          <div className={styles.currentVariants}>
            {principalDiagnosis.variants.map((variant, index) => {
              return (
                <div
                  style={{ display: "flex", gap: "1vw", alignItems: "center" }}
                  key={index}
                >
                  <label>
                    <input
                      className={styles.input}
                      type="checkbox"
                      disabled={principalDiagnosis.isFinalState}
                      onChange={() => {
                        dispatch(checkPrincipalDiagnosisAction(index));
                      }}
                      checked={variant.isChecked}
                    />
                    <span>✓</span>
                    <h3>{variant.variantName}</h3>
                  </label>
                </div>
              );
            })}
          </div>
          <div className={styles.footerButtons}>
            <button
              disabled={buttonsIsDisabled}
              onClick={navigateNextOrPrev}
              className="buttonBack"
            >
              Назад
            </button>
            {/* <button
              onClick={() => {
                setCommentary(true);
              }}
              className="buttonNext commentary-button"
            >
              Поделитесь Вашим профессиональным мнением
            </button> */}
            <button
              style={
                principalDiagnosis.variants.find((v) => v.isChecked)
                  ? {}
                  : { background: "grey" }
              }
              disabled={buttonsIsDisabled}
              onClick={navigateNextOrPrev}
              className="buttonNext"
            >
              Далее
            </button>
          </div>
        </>
      )}
      {alertDescription && (
        <AlertModal
          info={alertDescription}
          setAlertDescription={setAlertDescription}
          count={principalDiagnosis.numberOfAttempts}
        />
      )}
    </section>
  );
};

export default PrincipalDiagnosis;
